module.exports = __webpack_public_path__ + "img/UFI_Member-logo-06AB23A13E-seeklogo.com.bd093b95.png";